import { baseUrl } from "../../../../boot";
import axios from "axios";

// Add client
export const addBom = async (formData) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}bom/api/v1/create`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

export const deleteBom = async (ROWID) => {
  console.log({ ROWID })
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.delete(`${baseUrl}bom/api/v1/delete/${ROWID}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    console.log("Error is - ", error)
    throw error
  }
}

export const updateBom = async (ROWID, data) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.put(`${baseUrl}bom/api/v1/update/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}


export const getBomById = async (id) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}bom/api/v1/get/${id}`, {
      headers: {
        "auth-token": token,
      }
    })
    return response
  } catch (error) {
    throw error
  }
}



